export default __webpack_public_path__ + "static/media/yarik_sh.58d949b2.png";